// Constants for different requests for current reducer
export default {
  company: 'COMPANY',
  enableVisitorLog: 'ENABLE_VISITOR_LOG',
  disableVisitorLog: 'DISABLE_VISITOR_LOG',
};
